import { render } from "./NewProject.vue?vue&type=template&id=30019974&scoped=true"
import script from "./NewProject.vue?vue&type=script&lang=js"
export * from "./NewProject.vue?vue&type=script&lang=js"

import "./NewProject.vue?vue&type=style&index=0&id=30019974&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30019974"]])

export default __exports__